import { Injectable } from "@angular/core";
import { NumberTypeEnum } from "src/app/enums/number-type.enum";

@Injectable({
    providedIn: 'root'
})

export class UtilRandom {

    public static generateRandomNumberByType(numberType: NumberTypeEnum): number {
        if (numberType === NumberTypeEnum.ODD) {
            return UtilRandom.generateRandomOddNumber();
        } else {
            return UtilRandom.generateRandomEvenNumber();
        }
    }

    public static generateRandomEvenNumber(): number {
        let randonEvenNumber = 2;
        const minValue = 10000;
        const maxValue = 99999;
        try {
            randonEvenNumber =
                UtilRandom.getRandomIntegerNumberBetween(minValue, maxValue) * 2;
        } catch (error) { }
        return randonEvenNumber;
    }

    public static generateRandomOddNumber(): number {
        return UtilRandom.generateRandomEvenNumber() + 1;
    }
    
    public static getRandomIntegerNumberBetween(
        minValue: number,
        maxValue: number
    ): number {
        return Math.floor(Math.random() * (maxValue - minValue)) + minValue;
    }
}
